import { render, staticRenderFns } from "./AboutMenuLink.vue?vue&type=template&id=0899491b&scoped=true"
import script from "./AboutMenuLink.vue?vue&type=script&lang=js"
export * from "./AboutMenuLink.vue?vue&type=script&lang=js"
import style0 from "./AboutMenuLink.vue?vue&type=style&index=0&id=0899491b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0899491b",
  null
  
)

export default component.exports